import { MutableRefObject, useState } from "react";
import { ExamContainerInterface, ExerciseInterface, ObjectiveInterface } from "../../interfaces/examInterfaces";
import { DIALOGS } from "../Dialogs/dialogReducer";
import { useDispatch, useSelector } from "react-redux";
import { MANIPULATE_EXERCISES_TYPES } from "./Reducers/ManipulateExercisesReducer";
import { handleOpenDialog } from "./Functions/FunctionsMain";
import { RootState } from "../..";
import { LayoutExamId, LayoutExamTypeKeys } from "../../enums/layoutExamTypes";
import { LegacyExamContainer } from "./Layouts/Legacy/LegacyExamContainer";
import { AllalinhornExamContainer } from "./Layouts/Allalinhorn/AllalinhornExamContainer";
import { PizLinardExamContainer } from "./Layouts/PizLinard/PizLinardExamContainer";
import { GrandCombinExamContainer } from "./Layouts/GrandCombin/GrandCombinExamContainer";

export const ExamContainer = ({
  pageIndex,
  selectedObjective,
  pageExercises,
  exerciseRefs,
  pages,
  examName,
  amountExercises,
  totalPoints,
  imageUrls,
  solutionImageUrls,
  isCreatingAllPages,
  sortedExercises,
  selectedLayout,
  groupColorDark,
  groupColorLight,
}: {
  pageIndex: number;
  selectedObjective: ObjectiveInterface | null;
  pageExercises: ExerciseInterface[];
  exerciseRefs: MutableRefObject<(HTMLDivElement | null)[]>;
  pages: ExerciseInterface[][];
  examName: string;
  amountExercises: number;
  totalPoints: number;
  imageUrls: { [key: string]: string };
  solutionImageUrls: { [key: string]: string };
  isCreatingAllPages: boolean;
  sortedExercises: ExerciseInterface[];
  selectedLayout: LayoutExamTypeKeys;
  groupColorDark: string;
  groupColorLight: string;
}) => {
  const [showAddExercise, setShowAddExercise] = useState(false);
  const dispatch = useDispatch();
  const zoomFactor = useSelector((state: RootState) => state.examBuilder.main.zoomFactor);

  function openAddExerciseDialog() {
    let indexOfNewExercises = 0;
    for (let index = 0; index < pageIndex; index++) {
      const amountExercises = pages[index].length;
      indexOfNewExercises = indexOfNewExercises + amountExercises;
    }

    setIndex(indexOfNewExercises);
    handleOpenDialog(DIALOGS.SELECT_EXERCISES_EXAM_DIALOG);
  }

  function setIndex(index: number) {
    dispatch({ type: MANIPULATE_EXERCISES_TYPES.INDEX_NEW_EXERCISES, payload: index });
  }

  const layoutData: ExamContainerInterface = {
    pageIndex,
    selectedObjective,
    pageExercises,
    exerciseRefs,
    pages,
    examName,
    amountExercises,
    totalPoints,
    imageUrls,
    solutionImageUrls,
    isCreatingAllPages,
    sortedExercises,
    zoomFactor,
    openAddExerciseDialog,
    showAddExercise,
    setShowAddExercise,
    groupColorDark,
    groupColorLight,
  };

  switch (selectedLayout) {
    case LayoutExamId.LEGACY:
      return <LegacyExamContainer {...layoutData} />;

    case LayoutExamId.ALLALINHORN:
      return <AllalinhornExamContainer {...layoutData} />;

    case LayoutExamId.PIZ_LINARD:
      return <PizLinardExamContainer {...layoutData} />;

    case LayoutExamId.GRAND_COMBIN:
      return <GrandCombinExamContainer {...layoutData} />;

    default:
      return <LegacyExamContainer {...layoutData} />;
  }
};
